// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3NZw0","alertIcon":"ConfirmModal_alertIcon__37rFX"};